module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_flower-1b74a1200b68aeb86d65bbd2edaf2db6.jpg";